export default "__VITE_ASSET__DDXqymzE__"